import { pageRoutes } from './routes';

export const navigateToLoginPage = () => {
  // navigating using next js router causes some fetching errors and since this is an external page is does not make any difference
  window.location.replace(pageRoutes.login);
};
